<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import autofit from "./utils/autofit";
import { isPc } from "./utils/utils";
export default {
  name: "App",
  mounted() {
    if (isPc()) {
      autofit.init();
      if (window.location.pathname.indexOf("pc") == -1) {
        this.$router.replace("/pc");
      }
    } else {
      if (window.location.pathname.indexOf("mobile") == -1) {
        this.$router.replace("/mobile");
      }
    }
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue